import { render, staticRenderFns } from "./PartnersList.vue?vue&type=template&id=1fb4166f&scoped=true&"
import script from "./PartnersList.vue?vue&type=script&lang=js&"
export * from "./PartnersList.vue?vue&type=script&lang=js&"
import style0 from "./PartnersList.vue?vue&type=style&index=0&id=1fb4166f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb4166f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDataTable,VSelect})
